import React from 'react';

export default function CopyToClipboard(props) {
  return (
    <svg width='32' height='32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M10 5h10a2 2 0 0 1 2 2v.12H9.987a2 2 0 0 0-2 2V24A1.987 1.987 0 0 1 6 22.013V9a4 4 0 0 1 4-4z'
          fill='currentColor'
        />
        <rect stroke='currentColor' x='10.5' y='9.5' width='15' height='18' rx='2' />
      </g>
    </svg>
  );
}
